<template>
    <a-modal
      title="录入成本"
      centered
      :width="640"
      :mask-closable="false"
      :visible="showForm"
      :confirmLoading="loading"
      @cancel="close"
    >
        <a-form-model
          ref="form"
          :model="model"
          :rules="rules"
          :label-col="labelCol"
          :wrapper-col="wrapperCol"
        >
            <a-spin :spinning="loading">
                <a-form-model-item label="日期" prop="day">
                  <a-date-picker v-model="model.day" valueFormat="YYYY-MM-DD" style="width:100%" />
                </a-form-model-item>

                <a-form-model-item label="成本" prop="cost" help="填写当天消耗金额">
                  <a-input v-model="model.cost"/>
                </a-form-model-item>

            </a-spin>
        </a-form-model>

       

        <template slot="footer">
            <a-button @click="close" :disabled="loading">取消</a-button>
            <a-button type="primary" @click="submit" :disabled="loading">确定</a-button>
        </template>
    </a-modal>
</template>

<style lang="less" scoped>
@import 'FillCost';
</style>

<script>
import FillCost from './FillCost'

export default FillCost
</script>
